import { render, staticRenderFns } from "./recruit.vue?vue&type=template&id=35e55c38&scoped=true&"
import script from "./recruit.vue?vue&type=script&lang=js&"
export * from "./recruit.vue?vue&type=script&lang=js&"
import style0 from "./recruit.vue?vue&type=style&index=0&id=35e55c38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e55c38",
  null
  
)

export default component.exports